/* React */
import React from "react";

/* Ionic */
import { IonGrid, IonRow, IonCol } from "@ionic/react";

/* Components */
import MinimalPieChart from "src/components/charts/chart-legend/minimal-pie-chart/MinimalPieChart";
import Cohorts from "src/components/charts/chart-legend/cohorts/Cohorts";

/* Stylesheet */
import styles from "./ChartLegend.module.scss";

/* Interfaces */
import { LegendProps } from "src/shared/interfaces/charts/Legend";

const ChartLegend: React.FC<{
  chartLegendInfo: LegendProps[];
}> = ({ chartLegendInfo }) => {
  return (
    <IonGrid className={styles.chart_legend}>
      <IonRow className={styles.row}>
        <IonCol
          className={styles.col}
          sizeXs="12"
          sizeXl="6"
        >
          <Cohorts chartLegendInfo={chartLegendInfo} />
        </IonCol>
        <IonCol
          className={`${styles.col} ${styles.chart_col}`}
          sizeXs="12"
          sizeXl="6"
        >
          <MinimalPieChart
            chartLegendInfo={chartLegendInfo}
          />
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export default ChartLegend;
